var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitingRoomIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3V5H20M1 19.5H8M7.5 14V6.5H6.328C5.66203 6.50001 5.015 6.72161 4.48886 7.12988C3.96272 7.53816 3.58738 8.10989 3.422 8.755L1.5 16.25V16.5H10.5V18C10.5 19.5 10.5 20.5 11.25 22C11.25 22 12 23.5 13 23.5M18 9.5C16.8065 9.5 15.6619 9.02589 14.818 8.18198C13.9741 7.33807 13.5 6.19347 13.5 5C13.5 3.80653 13.9741 2.66193 14.818 1.81802C15.6619 0.974106 16.8065 0.5 18 0.5C19.1935 0.5 20.3381 0.974106 21.182 1.81802C22.0259 2.66193 22.5 3.80653 22.5 5C22.5 6.19347 22.0259 7.33807 21.182 8.18198C20.3381 9.02589 19.1935 9.5 18 9.5ZM7.35 4.5C7.35 4.5 5.75 3.5 5.75 2.25C5.75 2.02045 5.79521 1.79315 5.88306 1.58107C5.9709 1.36899 6.09966 1.17629 6.26198 1.01398C6.42429 0.85166 6.61699 0.722904 6.82907 0.635059C7.04115 0.547213 7.26845 0.502 7.498 0.502C7.72755 0.502 7.95485 0.547213 8.16693 0.635059C8.37901 0.722904 8.57171 0.85166 8.73402 1.01398C8.89634 1.17629 9.0251 1.36899 9.11294 1.58107C9.20079 1.79315 9.246 2.02045 9.246 2.25C9.246 3.5 7.65 4.5 7.65 4.5H7.35Z",
    stroke: "#40D2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingRoomIcon);
export default __webpack_public_path__ + "static/media/WaitingRoomIcon.a39fd65286f9b5a2313c1a05fcd9f69b.svg";
export { ForwardRef as ReactComponent };